<template>
  <div>
    <Banner theme="purple">
      <template v-slot:title> Countdown Clocks </template>
      <template v-slot:description>
        The Countdown Clock is a countdown clock :) Set a date & time and you
        can display the clock on any page on your site.
      </template>
      <template v-slot:image>
        <img
          src="@/assets/banners/widgets/countdowns.svg"
          alt="Countdown Clocks"
        />
      </template>
    </Banner>

    <IndexPageActions
      :sort-list="sortList"
      btn-text="New Countdown Clock"
      btn-to="/widgets/countdowns/new"
      :sort-by.sync="sortBy"
      search-placeholder="Search Countdowns"
      :search-text.sync="searchText"
    />

    <div v-if="list">
      <CountdownsDataTable
        v-if="computedList.length"
        :list="computedList"
        @destroy="destroy"
        @duplicate="duplicate"
      />
      <div v-else class="no-entries">No Countdowns</div>
    </div>
    <Spinner v-else relative />
  </div>
</template>

<script>
import IndexPage from "../index-page";
import CountdownsDataTable from "@/components/dataview/countdowns.datatable";

export default {
  name: "WidgetsCountdownClocksPage",
  components: { CountdownsDataTable },
  extends: IndexPage,
  metaInfo() {
    return {
      title: "Countdowns",
    };
  },
  methods: {
    async fetchList() {
      const { data } = await this.$api.Countdown.get({
        sort_by: this.sortBy,
      });
      this.list = data;
    },
    async destroy(item) {
      const confirmed = await this.$confirmWindow({ title: "Are you sure?" });
      if (!confirmed) return;
      await this.$api.Countdown.destroy({ id: item.id });
      this.list = this.list.filter((t) => t.id != item.id);
    },
    async duplicate(item) {
      await this.$api.Countdown.duplicate({ id: item.id });
      this.fetchList();
    },
  },
};
</script>

<style scoped lang="scss"></style>
